import { User, Mail, Phone, Building, MapPin, FileText } from 'lucide-react';

export default function ProfileForm({ formData, profile, isEditing, onFieldChange }) {
    const fields = [
        { key: 'name', label: 'Ad Soyad', icon: User, type: 'text', colSpan: 1 },
        { key: 'email', label: 'E-posta', icon: Mail, type: 'email', colSpan: 1 },
        { key: 'phone', label: 'Telefon', icon: Phone, type: 'tel', colSpan: 1 },
        { key: 'company', label: 'Şirket', icon: Building, type: 'text', colSpan: 1 },
        { key: 'address', label: 'Adres', icon: MapPin, type: 'text', colSpan: 2 },
        { key: 'bio', label: 'Hakkımda', icon: FileText, type: 'textarea', colSpan: 2 },
    ];

    return (
        <div className="bg-bg-secondary rounded-2xl border border-border-light overflow-hidden">
            {/* Header */}
            <div className="px-6 py-4 border-b border-border-light bg-gradient-to-r from-bg-tertiary/50 to-transparent">
                <h3 className="text-lg font-semibold text-text-primary">Kişisel Bilgiler</h3>
                <p className="text-sm text-text-tertiary mt-0.5">Profil bilgilerinizi görüntüleyin ve güncelleyin</p>
            </div>

            {/* Form Fields */}
            <div className="p-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    {fields.map((field) => {
                        const Icon = field.icon;
                        const value = isEditing ? formData[field.key] : profile[field.key];

                        return (
                            <div
                                key={field.key}
                                className={field.colSpan === 2 ? 'md:col-span-2' : ''}
                            >
                                <label className="flex items-center gap-2 text-sm font-medium text-text-secondary mb-2">
                                    <Icon size={15} className="text-text-muted" />
                                    {field.label}
                                </label>

                                {isEditing ? (
                                    field.type === 'textarea' ? (
                                        <textarea
                                            className="w-full px-4 py-3 rounded-xl border border-border-light bg-bg-primary text-text-primary placeholder:text-text-muted resize-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
                                            rows={3}
                                            value={value}
                                            onChange={(e) => onFieldChange(field.key, e.target.value)}
                                            placeholder={`${field.label} girin...`}
                                        />
                                    ) : (
                                        <input
                                            type={field.type}
                                            className="w-full px-4 py-3 rounded-xl border border-border-light bg-bg-primary text-text-primary placeholder:text-text-muted focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
                                            value={value}
                                            onChange={(e) => onFieldChange(field.key, e.target.value)}
                                            placeholder={`${field.label} girin...`}
                                        />
                                    )
                                ) : (
                                    <div className="px-4 py-3 rounded-xl bg-bg-tertiary/50 border border-transparent">
                                        <p className="text-text-primary">
                                            {value || <span className="text-text-muted italic">Belirtilmemiş</span>}
                                        </p>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
